<template>
  <div class="icon-menu">
    <el-tooltip
      v-for="item in routes"
      :key="item.uri"
      :content="item.name"
      placement="right"
      :open-delay="200"
    >
      <div
        class="icon-menu-item"
        :class="{ 'is-active': isActiveMenu(item) }"
        @click="navigateTo(item.uri)"
      >
        <i :class="getIcon(item)"></i>
        <span class="icon-label">{{ item.name ? item.name.substring(0, 2) : '' }}</span>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ProjectSideMenu',

  computed: {
    routes () {
      // 优先使用 survey 项目的菜单（从权限表 project='survey' 筛选）
      const surveyRoutes = (this.$store.state.surveyRoutes || []).filter(item => item.is_menu === '1')
      
      // 如果有 survey 菜单权限则使用，否则使用默认菜单
      if (surveyRoutes.length > 0) {
        return surveyRoutes
      }
      
      // 默认菜单（用于权限表尚未配置 survey 菜单的情况）
      return [
        { id: 1, name: '项目', uri: '/project', icon: 'el-icon-folder', is_menu: '1' },
        { id: 2, name: '回收站', uri: '/recycle', icon: 'el-icon-delete', is_menu: '1' },
        { id: 3, name: '设置', uri: '/settings', icon: 'el-icon-setting', is_menu: '1' }
      ]
    },
    
    // 获取当前路径匹配的一级菜单
    currentActiveRoute() {
      const path = this.$route.path
      const metaActive = this.$route.meta?.active
      
      // 首页 "/" 匹配 "项目" 菜单
      if (path === '/' || path === '') {
        return this.routes.find(r => r.uri === '/' || r.uri === '') || this.routes[0]
      }
      
      // 使用 meta.active 查找
      if (metaActive) {
        const allPermissions = this.$store.state.allPermissions || []
        let matchedRoute = this.routes.find(r => r.uri === metaActive)
        if (matchedRoute) return matchedRoute
        
        // 如果 metaActive 是二级菜单，找它的父菜单
        const item = allPermissions.find(p => p.uri === metaActive)
        if (item && item.parent_id) {
          const parent = allPermissions.find(p => p.id === item.parent_id)
          if (parent) {
            matchedRoute = this.routes.find(r => r.uri === parent.uri)
            if (matchedRoute) return matchedRoute
          }
        }
      }
      
      // /project 路径匹配 "项目" 菜单
      if (path.startsWith('/project')) {
        return this.routes.find(r => r.uri === '/' || r.uri === '/project') || this.routes[0]
      }
      
      // 通过路径前缀匹配（排除首页）
      for (const route of this.routes) {
        if (route.uri && route.uri !== '/' && route.uri !== '') {
          if (path === route.uri || path.startsWith(route.uri + '/')) {
            return route
          }
        }
      }
      
      return this.routes[0] || null
    }
  },
  
  methods: {
    getIcon(item) {
      const iconMap = {
        '项目': 'el-icon-folder',
        '回收站': 'el-icon-delete',
        '设置': 'el-icon-setting'
      }
      return item.icon || iconMap[item.name] || 'el-icon-menu'
    },
    
    isActiveMenu(item) {
      const activeRoute = this.currentActiveRoute
      if (!activeRoute) return false
      return activeRoute.uri === item.uri
    },
    
    navigateTo(uri) {
      // 处理 "/" 和 "/project" 都指向项目列表
      const targetUri = (uri === '/' || uri === '') ? '/project' : uri
      if (this.$route.path !== targetUri) {
        this.$router.push(targetUri)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 50px;
}

.icon-menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 58px;
  margin-bottom: 6px;
  border-radius: 10px;
  color: #8c8c8c;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-decoration: none;
  
  &:hover {
    background: #f0f5ff;
    color: #1890ff;
    
    .icon-label {
      color: #1890ff;
    }
  }
  
  &.is-active {
    background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%) !important;
    color: #fff !important;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.35);
    
    .icon-label {
      color: #fff !important;
    }
  }
  
  i {
    font-size: 22px;
    margin-bottom: 4px;
  }
  
  .icon-label {
    font-size: 11px;
    color: #8c8c8c;
    line-height: 1.2;
    text-align: center;
  }
}
</style>
